import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f4e8264&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0f4e8264&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e8264",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/live-front-end_XotX/plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f4e8264')) {
      api.createRecord('0f4e8264', component.options)
    } else {
      api.reload('0f4e8264', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f4e8264&scoped=true", function () {
      api.rerender('0f4e8264', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/nosocomiumList/index.vue"
export default component.exports